module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_sunshouse-3edd7a5f995f525a707b25fc2a01c2a6.jpg";